import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
const heroImageUrl = "https://cdn.magicpatterns.com/uploads/mA4eGdJuABzhGaQsNzJb9T/Mockup_-_1x1_-_OFN6_-_Epilepsia.webp";
const preconnects = ["https://cdn.magicpatterns.com", "https://fonts.googleapis.com", "https://fonts.gstatic.com"];
preconnects.forEach(origin => {
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = origin;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
});
const preloadHero = document.createElement("link");
preloadHero.rel = "preload";
preloadHero.as = "image";
preloadHero.href = heroImageUrl;
preloadHero.setAttribute("fetchpriority", "high");
document.head.appendChild(preloadHero);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-204" data-mp="2y0ggehj0ofpb" />);
}